module.exports = __webpack_public_path__ + "img/3.9780b444.jpg";